function Chain({ codes, amp, step }: { codes: string[]; amp: number; step: number }) {
	const pts = codes.map((_, i) => ({
		x: i * step,
		y: i % 2 === 0 ? 0 : amp,
	}));

	const d = pts.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`).join(" ");

	return (
		<>
			<path d={d} />
			{pts.map((p, i) => (
				<g key={i}>
					<circle cx={p.x} cy={p.y} r="2" fill="currentColor" stroke="none" />
					<line
						x1={p.x}
						y1={p.y}
						x2={p.x}
						y2={p.y < amp / 2 ? p.y - 8 : p.y + 8}
						strokeWidth="0.7"
						strokeOpacity="0.7"
					/>
					<text
						x={p.x}
						y={p.y < amp / 2 ? p.y - 14 : p.y + 18}
						textAnchor="middle"
						fontSize="9"
						fontFamily="ui-monospace, monospace"
						letterSpacing="0.5"
						fill="currentColor"
						stroke="none"
						fillOpacity="0.85"
					>
						{codes[i]}
					</text>
				</g>
			))}
		</>
	);
}

export function AminoBackdrop() {
	return (
		<div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
			<svg
				viewBox="0 0 1600 900"
				preserveAspectRatio="xMidYMid slice"
				className="absolute inset-0 h-full w-full text-primary opacity-[0.08]"
				fill="none"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<g transform="translate(60,120)">
					<Chain codes={["Gly", "Ala", "His", "Lys"]} amp={6} step={64} />
				</g>
				<g transform="translate(1100,80)">
					<Chain codes={["Glu", "Asp", "Pro"]} amp={5} step={56} />
				</g>
				<g transform="translate(-20,440)">
					<Chain codes={["Ser", "Cys", "Phe", "Leu", "Arg"]} amp={7} step={70} />
				</g>
				<g transform="translate(1180,520)">
					<Chain codes={["Met", "Thr"]} amp={5} step={60} />
				</g>
				<g transform="translate(420,780)">
					<Chain codes={["Trp", "Val", "Ile", "Asn"]} amp={6} step={60} />
				</g>
				<g transform="translate(950,860)">
					<Chain codes={["Gln", "Aib", "Hyp"]} amp={5} step={56} />
				</g>
			</svg>
		</div>
	);
}
